@import "@SeemplicityDev/shared/src/design-system/styles/constants.scss";

.menu-item-tabs-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  .loading-tabs {
    margin-block: var(--spacing-4);
  }
  .menu-item-tab-link {
    display: block;
    width: 100%;
    overflow: hidden;
    border-radius: var(--border-radius-s-m);
    transition:
      color 0.1s ease-in-out,
      background-color 0.1s ease-in-out;
    &.menu-item-tab-link-active {
      box-shadow: var(--menu-button-box-shadow);
      background: var(--menu-item-tab-bg-color-active);
      .menu-item-tab-icon,
      .menu-item-tab-title {
        color: var(--menu-item-tab-color-active);
      }
    }
    &:hover {
      box-shadow: var(--menu-button-box-shadow);
      background: var(--menu-item-tab-bg-color-hover);
    }
    &.is-disabled,
    &.is-disabled:hover {
      cursor: default;
      color: var(--menu-item-tab-color-disabled);
      box-shadow: none;
      background: var(--menu-item-tab-bg-color-disabled);
    }
  }
  .menu-item-tab {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: var(--spacing-2);
    padding: var(--spacing-2) var(--spacing-3);
    width: 100px;
    height: 64px;
    color: var(--menu-item-tab-color);
    cursor: pointer;
    user-select: none;

    .menu-item-tab-icon {
      font-size: 24px;
    }

    .menu-item-tab-title-wrapper {
      display: flex;
      gap: var(--spacing-1);
      max-width: 100%;
      overflow: hidden;
      .menu-item-tab-title {
        @include button-large-typography;
        text-align: center;
        @include ellipsis(100%);
      }
    }

    &.is-disabled,
    &.is-disabled:hover {
      cursor: default;
      color: var(--menu-item-tab-color-disabled);
      box-shadow: none;
      background: var(--menu-item-tab-bg-color-disabled);
    }
  }

  &.is-horizontal {
    &.is-fullwidth {
      width: 100%;
    }
  }
  &.is-vertical {
    flex-direction: column;
    gap: var(--spacing-2);
    .menu-item-tab {
      height: 44px;
      width: 100%;
      flex-flow: row nowrap;
      justify-content: flex-start;
      &.is-loading {
        pointer-events: none;
      }
    }
    .widget-type-item {
      text-align: center;
    }
    .menu-item-tab-icon {
      font-size: var(--icon-size-m);
    }
  }
}

.menu-item-tab-scrollable-content {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-4);
  height: 100%;

  & > :last-child {
    min-height: calc(var(--container-height, 550px) - 10px);
    height: 100%;
  }

  .menu-item-section-banner {
    display: flex;
    flex-direction: column;
    margin-block: var(--spacing-4) var(--spacing-2);
  }

  .menu-item-tab-content {
    position: relative;
    display: flex;
    flex-direction: column;
    gap: var(--spacing-2);
    padding: var(--spacing-1) var(--spacing-4) var(--spacing-4) var(--spacing-4);
    background: var(--details-pane-inner-content-background-color);
    border-radius: var(--border-radius-s-m);
    transition: box-shadow 0.1s ease-in-out;
    &.is-active {
      box-shadow: var(--shadow-low);
      transition: box-shadow 0.1s ease-in-out;
      border: 1px solid var(--border-color);
    }
    .tab-title-container {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      width: 100%;

      .tab-title {
        color: var(--text-color-main);
      }

      .tab-title-badge {
        margin-left: var(--spacing-2);
      }

      .tab-section-action {
        margin-left: auto;
      }
    }
  }
}
